import {FETCH_MY_SUPPORT_CONTACT, FETCH_MY_SUPPORT_TOPICS, SEND_MY_SUPPORT_TICKET} from "./actions.type";
import {
    FETCHED_MY_SUPPORT_CONTACT, FETCHED_MY_SUPPORT_TOPICS
} from "./mutations.type";
import {MySupportService} from "../common/api.service";
import {asyncState} from "./utils/async";

export function getInitialState() {
    return {
        contact: null,
        topics: [],
        ...asyncState(SEND_MY_SUPPORT_TICKET, FETCH_MY_SUPPORT_CONTACT, FETCHED_MY_SUPPORT_CONTACT)
    }
}

const state = getInitialState();

const getters = {
    contact(state) {
        return state.contact;
    },
    topics(state) {
        return state.topics;
    }
};

const actions = {
// Support Ticket
    [SEND_MY_SUPPORT_TICKET]({commit}, params) {
        let payload = {
            topic: params.topic,
            message: params.message
        };
        return MySupportService.sendSupportTicket(payload, params.files)
            .catch(error => {
                throw new Error(error);
            });
    },
    [FETCH_MY_SUPPORT_CONTACT]({commit}) {
        return MySupportService.getContact()
            .then((response) => commit(FETCHED_MY_SUPPORT_CONTACT, response))
            .catch(error => {
                throw new Error(error);
            });
    },
    [FETCH_MY_SUPPORT_TOPICS]({commit}) {
        return MySupportService.getTopics()
            .then((response) => commit(FETCHED_MY_SUPPORT_TOPICS, response))
            .catch(error => {
                throw new Error(error);
            });
    }
};

const mutations = {
    [FETCHED_MY_SUPPORT_CONTACT](state, {data}) {
        state.contact = {
            name: data.name,
            title: data.title,
            phoneNumber: data.phone,
            email: data.email,
            image: data.imageLink
        };
    },
    [FETCHED_MY_SUPPORT_TOPICS](state, {data}) {
        state.topics = data.items && data.items.map((option) => ({
            code: option.name,
            text: option.displayName
        }));
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
